import { render, staticRenderFns } from "./InventoryOverviewGenerationModal.vue?vue&type=template&id=72873c2f&scoped=true"
import script from "./InventoryOverviewGenerationModal.vue?vue&type=script&lang=js"
export * from "./InventoryOverviewGenerationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72873c2f",
  null
  
)

export default component.exports